import { PartnerBulkUploadPayload } from '../utils/formatPartnerForBulkUpload';
import { formatExcelDateForPreview } from '../utils/formatExcelDateValue';

const formatCellValue = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (typeof value === 'boolean') {
    return String(value);
  }

  return String(value);
};

export type PartnerBulkPreviewColumn = {
  dbField: string;
  labelKey: string;
  getValue: (partner: PartnerBulkUploadPayload) => string;
};

export const PARTNER_BULK_PREVIEW_COLUMNS: PartnerBulkPreviewColumn[] = [
  { dbField: 'name', labelKey: 'Name', getValue: (p) => formatCellValue(p.name) },
  { dbField: 'cif', labelKey: 'Cif', getValue: (p) => formatCellValue(p.cif) },
  { dbField: 'email', labelKey: 'Email', getValue: (p) => formatCellValue(p.email) },
  { dbField: 'phone', labelKey: 'Phone', getValue: (p) => formatCellValue(p.phone) },
  {
    dbField: 'phoneSecondary',
    labelKey: 'PhoneSecondary',
    getValue: (p) => formatCellValue(p.phoneSecondary),
  },
  {
    dbField: 'externalId',
    labelKey: 'ExternalId',
    getValue: (p) => formatCellValue(p.externalId),
  },
  { dbField: 'idType', labelKey: 'IdType', getValue: (p) => formatCellValue(p.idType) },
  {
    dbField: 'nationality',
    labelKey: 'Nationality',
    getValue: (p) => formatCellValue(p.nationality),
  },
  { dbField: 'gender', labelKey: 'Gender', getValue: (p) => formatCellValue(p.gender) },
  {
    dbField: 'isNaturalPerson',
    labelKey: 'LegalPerson',
    getValue: (p) => formatCellValue(p.isNaturalPerson),
  },
  {
    dbField: 'birthdate',
    labelKey: 'BirthDate',
    getValue: (p) => formatExcelDateForPreview(p.birthdate),
  },
  {
    dbField: 'deceaseDate',
    labelKey: 'DeceaseDate',
    getValue: (p) => formatExcelDateForPreview(p.deceaseDate),
  },
  {
    dbField: 'civilStatus',
    labelKey: 'CivilStatus',
    getValue: (p) => formatCellValue(p.civilStatus),
  },
  {
    dbField: 'employeeNumber',
    labelKey: 'EmployeeNumber',
    getValue: (p) => formatCellValue(p.employeeNumber),
  },
  {
    dbField: 'bankAccountNumber',
    labelKey: 'BankAccountNumber',
    getValue: (p) => formatCellValue(p.bankAccountNumber),
  },
  {
    dbField: 'address.line1',
    labelKey: 'Address',
    getValue: (p) => formatCellValue(p.address?.line1),
  },
  {
    dbField: 'address.city',
    labelKey: 'City',
    getValue: (p) => formatCellValue(p.address?.city),
  },
  {
    dbField: 'address.zip',
    labelKey: 'Zip',
    getValue: (p) => formatCellValue(p.address?.zip),
  },
  {
    dbField: 'address.country',
    labelKey: 'Country',
    getValue: (p) => formatCellValue(p.address?.country),
  },
  {
    dbField: 'taxAddress.line1',
    labelKey: 'TaxAddress',
    getValue: (p) => formatCellValue(p.taxAddress?.line1),
  },
  {
    dbField: 'category',
    labelKey: 'Category',
    getValue: (p) => formatCellValue(p.categoryLabel || p.category),
  },
  { dbField: 'source', labelKey: 'Source', getValue: (p) => formatCellValue(p.source) },
];
